import { createRouter, createWebHistory } from 'vue-router'
import Itinerary from '@/modules/Itinerary/Itinerary.vue'
import PublishPreview from '@/modules/SelfServePublish/PublishPreview.vue'
import TripLaunched from '../modules/SelfServePublish/TripLaunched.vue'
import TripTermsConditions from '../modules/SelfServePublish/TripTermsConditions.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'product',
      path: '/:lang/epic-adventures/:country/:id',
      component: Itinerary,
    },
    {
      name: 'product-preview',
      path: '/:lang/epic-adventures/:country/:id/preview',
      component: Itinerary,
      props: { isPreview: true },
    },
    {
      name: 'product-launch-preview',
      path: '/:lang/epic-adventures/:country/:id/launch-preview',
      component: PublishPreview,
    },
    {
      name: 'product-terms-conditions',
      path: '/:lang/epic-adventures/:country/:id/terms-conditions',
      component: TripTermsConditions,
    },
    {
      name: 'product-launched',
      path: '/:lang/epic-adventures/:country/:id/launched',
      component: TripLaunched,
    },
  ],
})
